import { Button } from '@/global/components/Button'
import CircularProgress from '@/global/components/CircularProgress'
import localeText from '@/locales/datagrid'
import { PrinterIcon } from 'lucide-react'
import { useTableApiContext } from '../../utils/table-context'

interface IProps {
    disabled?: boolean
    handleClick: () => void
    isImprimindo: boolean
    className?: string
}

export default function ImprimirButton({
    disabled,
    handleClick,
    isImprimindo,
    className = '',
}: IProps) {
    const { rows } = useTableApiContext()

    return (
        <Button
            onClick={handleClick}
            disabled={isImprimindo || !rows.length || disabled}
            title={localeText.toolbarExportPrint}
            className={className}
            startIcon={
                isImprimindo ? (
                    <CircularProgress color="primary" size={16} />
                ) : (
                    <PrinterIcon size={16} />
                )
            }
        >
            <span className="hidden sm:block">
                {localeText.toolbarExportPrint}
            </span>
        </Button>
    )
}
